import { render, staticRenderFns } from "./UserIdpSetter.vue?vue&type=template&id=77f94e51&"
import script from "./UserIdpSetter.vue?vue&type=script&lang=js&"
export * from "./UserIdpSetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports